import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { routes } from "../routes";
import SettingsBilling from "./settings/SettingsBilling";

const DeveloperPortalRouter: React.FC = () => {
  return (
    <Switch>
      <Route exact path={routes.DEVELOPER_PORTAL_SETTINGS} component={SettingsBilling} />
      <Redirect exact from={routes.DEVELOPER_PORTAL_DASHBOARD} to={routes.DEVELOPER_PORTAL_SETTINGS} />
      <Redirect to={routes.DEVELOPER_PORTAL_SETTINGS} />
    </Switch>
  );
};

export default DeveloperPortalRouter;
